<template>

<section> 
      <b-container>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <b-img src="img/custom/lieber.png" fluid />
          </b-col>
          <b-col md="6" class="order-md-1">
            <div class="pr-md-5">
              <h1>Did you use artificial intelligence to create your art?</h1>

                    
<div class="hint" v-if="currentSnapWizard.has_ai_art == 1">
                        Unfortunately, we can no longer print books in which artificial intelligence was used. We have already made the experience that the color differences between the digital image and our print are too high and therefore we cannot guarantee 100% quality. We only want to publish high quality books and the satisfaction of our artists is most important to us.
                    </div>



                        <b-form-radio-group v-model="currentSnapWizard.has_ai_art">
                        <div>
                            <b-form-radio value="1" name="unchecked" class="mb-3">
                                Yes
                            </b-form-radio>
                        </div>
                        <div>
                            <b-form-radio value="0" name="checked" class="mb-3">
                                No
                            </b-form-radio>
                        </div>
                    </b-form-radio-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


   
   

</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap02',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
            if (
                this.currentSnapWizard.has_ai_art == 0
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');
        this.allDataValidated();
    }
};
</script>